import Vue from 'vue'

const offscreenMeasure = (Component, propsData = {}, to = document.body) => {
  const container = document.createElement('div')
  container.style.cssText = `
    position: fixed;
    visibility: hidden;
    pointer-events: none;
    z-index: -9999;
  `

  if (typeof to === 'string') {
    to = document.querySelector(to)
  }

  to.appendChild(container)

  const Constructor = Vue.extend(Component)
  const vm = new Constructor({ propsData }).$mount()
  container.appendChild(vm.$el)

  const { width, height } = vm.$el.getBoundingClientRect()

  vm.$destroy()
  container.remove()

  return { width, height }
}

export default offscreenMeasure
